module.exports = __webpack_public_path__ + "static/media/eyes-open.07b2fbeb.svg";